import * as Yup from 'yup'
import i18n from 'core/common/i18n'

export const SimpleProductStockFormSchema = Yup.object().shape({
  stocks: Yup.array().of(
    Yup.object().shape({
      quantity: Yup.number()
        .typeError(i18n.t('product.validations.required'))
        .min(0, i18n.t('product.validations.minValue'))
        .max(999999, i18n.t('product.validations.maxValueOrEqual', { count: 999999 }))
        .required(i18n.t('product.validations.required')),
      reserved: Yup.number(),
      name: Yup.string(),
      channel: Yup.string(),
      branch: Yup.string(),
      type: Yup.string(),
    })
  ),
})

export const VariationProductStockFormSchema = Yup.object().shape({
  variations: Yup.array()
    .of(
      Yup.object()
        .shape({
          stocks: Yup.array()
            .of(
              Yup.object()
                .shape({
                  quantity: Yup.number()
                    .typeError(i18n.t('product.validations.required'))
                    .min(0, i18n.t('product.validations.minValue'))
                    .max(999999, i18n.t('product.validations.maxValueOrEqual', { count: 999999 }))
                    .required(i18n.t('product.validations.required')),
                  reserved: Yup.number(),
                  name: Yup.string(),
                  channel: Yup.string(),
                  branch: Yup.string(),
                  type: Yup.string(),
                })
                .required(i18n.t('product.validations.required'))
            )
            .min(1, i18n.t('product.validations.required'))
            .required(i18n.t('product.validations.required')),
        })
        .required(i18n.t('product.validations.required'))
    )
    .min(1, i18n.t('product.validations.required'))
    .required(i18n.t('product.validations.required')),
})
